export function secondsToTimecode(seconds: number, forceHoursDisplay = false, showAfterDecimal: boolean = false): string {
    const hours = Math.floor(seconds / 3600);
    seconds = seconds % 3600;

    const minutes = Math.floor(seconds / 60);
    seconds = seconds % 60;

    const wholeSeconds = Math.floor(seconds);
    const fractional = seconds - wholeSeconds;

    const secondsWithDecimal = (wholeSeconds + fractional).toFixed(1);

    const formattedMinutes = minutes.toString().padStart(2, "0");
    // When showAfterDecimal is true, show one decimal place; otherwise show whole seconds only
    const formattedSeconds = showAfterDecimal
        ? secondsWithDecimal.padStart(4, "0") // ensures `9.2` → `09.2`
        : wholeSeconds.toString().padStart(2, "0");

    let timecode = `${formattedMinutes}:${formattedSeconds}`;

    if (hours > 0 || forceHoursDisplay) {
        const formattedHours = hours.toString().padStart(2, "0");
        timecode = `${formattedHours}:${timecode}`;
    }

    return timecode;
}